import * as React from 'react'
import type { CommonDeps } from '../base/CommonDeps'
import type { RenderCachedImage } from '../image/WithCachedImage'
import type { ParentInfo, ReportGuideExecution } from './Model'
import { GuidePresentationWithParentInfo } from './GuidePresentationWithParentInfo'
import { ViewReportsWithTitles } from '../report/viewReport/ViewReportsWithTitle'

interface Props {
    deps: CommonDeps
    downloadFile: (url: string, name: string, mimeType: string) => Promise<void>
    guideExecution: ReportGuideExecution
    onClickGuideParentInfo: (parentInfo: ParentInfo) => void
    renderCachedImage: RenderCachedImage
}

/**
 * A component that displays a viewable guide report.
 */
export function ReportGuidePresentation(props: Props) {
    const guideExecution = props.guideExecution
    const ancestorIds = guideExecution.customData?.ancestorIds || []
    const rootReportId = guideExecution.customData.root
    const lookup = guideExecution.customData.reports
    return (
        <GuidePresentationWithParentInfo
            deps={props.deps}
            guideParentInfo={props.guideExecution.parentInfo}
            onClickGuideParentInfo={props.onClickGuideParentInfo}
            renderCachedImage={props.renderCachedImage}
        >
            <div className="AppCore__guide__ReportGuidePresentation">
                {
                    <ViewReportsWithTitles
                        reportClientIds={[...ancestorIds, rootReportId]}
                        lookup={lookup}
                        deps={props.deps}
                        downloadFile={props.downloadFile}
                        renderCachedImage={props.renderCachedImage}
                    />
                }
            </div>
        </GuidePresentationWithParentInfo>
    )
}
